module.exports = __webpack_public_path__ + "static/img/faq1.93fd4d5.jpg";